<template>
  <div v-show="showLogin">
    <Head :title="__('Log In')"/>
    <form @submit.prevent="attempt" class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h2 class="text-2xl text-center font-normal mb-6 ">
        {{ __("Welcome Back!") }}
      </h2>
      <DividerLine/>
      <div class="mb-6">
        <label class="block mb-2" for="email">{{ __("Email Address") }}</label>
        <input v-model="form.email" class="form-control form-input form-control-bordered w-full" :class="{ 'form-input-border-error': form.errors.has('email') }" id="email" type="email" name="email" autofocus="" required/>
        <HelpText class="mt-2 text-red-500" v-if="form.errors.has('email')">
          {{ form.errors.first("email") }}
        </HelpText>
      </div>
      <div class="mb-6">
        <label class="block mb-2" for="password">{{ __("Password") }}</label>
        <input v-model="form.password" class="form-control form-input form-control-bordered w-full" :class="{ 'form-input-border-error': form.errors.has('password') }" id="password" type="password" name="password" required />
        <HelpText class="mt-2 text-red-500" v-if="form.errors.has('password')">
          {{ form.errors.first("password") }}
        </HelpText>
      </div>
      <div class="flex mb-6">
        <Checkbox @change="() => (form.remember = !form.remember)" :model-value="form.remember" dusk="remember-button" :label="__('Remember me')"/>
        <div v-if="supportsPasswordReset || forgotPasswordPath !== false" class="ml-auto">
          <Link v-if="forgotPasswordPath === false" :href="$url('/password/reset')" class="text-gray-500 font-bold no-underline" v-text="__('Forgot your password?')"/>
          <a v-else :href="forgotPasswordPath" class="text-gray-500 font-bold no-underline" v-text="__('Forgot your password?')"/>
        </div>
      </div>
      <DefaultButton class="w-full flex justify-center" type="submit">
        <span>
          {{ __("Log In") }}
        </span>
      </DefaultButton>
    </form>
  </div>
  <div v-if="showModal">
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h1 class="font-normal text-xl md:text-xl mb-3 flex items-center"><span>Ingrese su código de autenticación multifactor</span></h1>
      <div class="mb-6 mt-4">
        <input v-model="mfa_code" class="form-control form-input form-control-bordered w-full" :class="{ 'form-input-border-error': form.errors.has('mfa_code') }" id="mfa_code" type="text" name="mfa_code" minlength="6" maxlength="8" required/>
        <HelpText class="mt-2 text-gray-500">
          Ingrese el código de autenticación generado por su aplicación de autenticación.
        </HelpText>
      </div>
      <DefaultButton class="w-full flex justify-center" @click="challengeCode">
        <span>
          {{ __('Confirmar') }}
        </span>
      </DefaultButton>
      <div class="mt-4 text-center">
        <span class="lostText text-gray-500 hover:text-gray-400 cursor-pointer text-xs" @click="initRecovery">
          ¿Perdiste acceso a tu dispositivo de autenticación?
        </span>
      </div>
    </div>
  </div>
  <div v-if="showRecovery">
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h1 class="font-normal text-xl md:text-xl mb-3 flex items-center"><span>Ingrese su código de recuperación</span></h1>
      <div class="mb-6 mt-4">
        <input v-model="recovery_code" class="form-control form-input form-control-bordered w-full" :class="{ 'form-input-border-error': form.errors.has('recovery_code') }" id="recovery_code" type="text" name="recovery_code" required/>
        <HelpText class="mt-2 text-gray-500">
          Ingrese uno de los códigos de recuperación entregados en la generación de esta configuración. <span class="text-red-500">Esta acción representará un reinicio en su configuración MFA. Posteriormente será requerido que configure nuevamente.</span>
        </HelpText>
        <div class="mt-2 text-red-500" v-if="errors.length">
          <b>Por favor, corrige los siguientes errores:</b>
          <ol>
            <li v-for="error in errors">{{ error }}</li>
          </ol>
        </div>
      </div>
      <DefaultButton class="w-full flex justify-center" @click="recoveryProcess">
        <span>
          {{ __('Confirmar') }}
        </span>
      </DefaultButton>
    </div>
  </div>
</template>

<script>
  import Auth from '@/layouts/Auth'
  import { Button, Checkbox } from "laravel-nova-ui"

  export default {
    name: "LoginPage",
    layout: Auth,
    components: {
      Checkbox,
      Button,
    },
    data: () => ({
      form: Nova.form({
        email: "",
        password: "",
        remember: false,
      }),
      email: "",
      password: "",
      mfa_code: "",
      recovery_code: "",
      showLogin: true,
      showModal: false,
      showRecovery: false,
      errors: [],
    }),

    methods: {
      async attempt() {
        try {
          this.email = this.form.email;
          this.password = this.form.password;
          Nova.request().post(Nova.url("/auth/login"), {
            email: this.email,
            password: this.password,
          }).then(response => {
            if (response.status == 200) {
              if (response.data.two_factor == true) {
                this.showLogin = false
                this.showModal = true
              } else {
                Nova.visit({ url: "dashboards/main", remote: true })
              }
            }
          }).catch(error => {
            console.log(error)
            Nova.error("Autenticación no superada.")
          })
        } catch (error) {
          if (error.response?.status === 500) {
            Nova.error(this.__("There was a problem submitting the form."))
          }
        }
      },
      challengeCode() {
        Nova.request().post('/auth/two-factor-challenge', {
          code: this.mfa_code
        }).then(response => {
          if (response.status == 204) {
            
          }
        }).catch(error => {
          if (error.response?.status === 422) {
            Nova.error("Código de autenticación incorrecto")
          }
          console.log(error)
        })
      },
      recoveryProcess() {
        Nova.request().post('/auth/two-factor-challenge', {
          recovery_code: this.recovery_code
        }).then(response => {
          if (response.status == 204) {
            Nova.request().post('/auth/user/confirm-password', {
              password: this.password
            }).then(response => {
              if (response.status == 201) {
                Nova.request().delete('/auth/user/two-factor-authentication').then(response => {
                  Nova.visit({ url: "dashboards/main", remote: true })
                }).catch(error => {
                  console.log(error)
                })
              }
            }).catch(error => {
              console.log(error)
            })
          }
        }).catch(error => {
          if (error.response?.status === 422) {
            Nova.error("Código de recuperación incorrecto")
          }
          console.log(error)
        })
      },
      initRecovery() {
        this.showModal = false
        this.showRecovery = true
      },
    },
    computed: {
      supportsPasswordReset() {
        return Nova.config("withPasswordReset")
      },
      forgotPasswordPath() {
        return Nova.config("forgotPasswordPath")
      },
    },
    mounted() {
      //
    },
  }
</script>

<style scoped>
  span.lostText {
    text-decoration: underline
  }
</style>